// @flow
import Strings, { Images } from '@/constants'

const INFO = [
  {
    title: Strings.hottestDeals,
    description: Strings.ourRelationships,
    icon: Images.flame,
  },
  {
    title: Strings.wiserThanAnOwl,
    description: Strings.weveBeenAround,
    icon: Images.owl,
  },
  {
    title: Strings.raddest,
    description: Strings.ourFriendlyPros,
    icon: Images.raddest,
  },
]

export default INFO
